import api from './api'

export const paymentRecordService = {
  /**
   * 查询付款记录列表
   */
  fetchPaymentRecords(params) {
    return api.get('/payment-records', { params })
  },

  /**
   * 获取付款记录详情
   */
  getPaymentRecord(id) {
    return api.get(`/payment-records/${id}`)
  },

  /**
   * 更新付款记录状态
   */
  updatePaymentRecordStatus(id, status) {
    return api.put(`/payment-records/${id}/status`, { status })
  },

  /**
   * 批量更新付款记录状态
   */
  batchUpdateStatus(ids, status) {
    return api.put('/payment-records/batch-status', { ids, status })
  },

  /**
   * 执行对账
   */
  comparePaymentRecords(courseId) {
    return api.post(`/payment-records/courses/${courseId}/compare`)
  }
}

